import IconRefresh from '@bimser/icons/16/refresh';
import * as React from 'react';
import { BCButton, BCSpaceCompact, BCTreeSelect, BCTreeSelectRef } from '../../..';
import { IPropertyComponentProps } from '../../entities';

const inputStyleWithPromise: React.CSSProperties = { width: 'calc(100% - 35px)' };
const inputStyle: React.CSSProperties = { width: '100%' };
const buttonStyle: React.CSSProperties = { width: '35px', border: '1px solid #d9d9d9' };
const dropdownStyle: React.CSSProperties = { minWidth: 200, maxHeight: 350 };

const getPopupContainer = () => document.body;

export default function TreeSelectProperty(props: IPropertyComponentProps) {
	const { isPromise, multiple } = props.item.options || {};
	const { items, showSearch, virtual } = props.item.externalData || {};

	const treeSelect = React.useRef<BCTreeSelectRef>();
	const [options, setOptions] = React.useState(items);

	React.useEffect(() => {
		setOptions(items);
	}, [items]);

	React.useEffect(() => {
		getOptionsPromise();
	}, []);

	const getOptionsPromise = async (): Promise<any> => {
		if (isPromise && props.getOptionsPromise) {
			const result = await props.getOptionsPromise(props.item);
			setOptions(result.options);
		}
	};

	const onRefresh = async () => {
		if (props.onRefresh) {
			const result = await props.onRefresh(props.item);
			setOptions(result.options);
		}
	};

	const onChange = e => {
		if (props.customChangeEvent) {
			props.customChangeEvent(e);
		} else {
			props.onValueChanged(props.item, e);
		}
	};

	const getTreeSelect = (styleWithPromise?: React.CSSProperties) => {
		return (
			<BCTreeSelect
				ref={treeSelect}
				treeData={options}
				value={props.value || props.item.placeholder}
				onChange={onChange}
				disabled={props.item.disabled || props.item.readOnly}
				style={props.style || styleWithPromise || inputStyle}
				dropdownStyle={dropdownStyle}
				multiple={multiple}
				treeNodeLabelProp="key"
				showSearch={showSearch}
				virtual={virtual}
				readOnly={props.readonly}
				allowClear={props.item.allowClear}
				getPopupContainer={getPopupContainer}
				size="small"
			/>
		);
	};

	if (isPromise) {
		return (
			<BCSpaceCompact
				block
				size="small"
			>
				{getTreeSelect(inputStyleWithPromise)}
				<BCButton
					style={buttonStyle}
					icon={<IconRefresh />}
					onClick={onRefresh}
					disabled={props.readonly}
				/>
			</BCSpaceCompact>
		);
	}

	return getTreeSelect();
}
